module.exports = __webpack_public_path__ + "static/hero-img-4920516d5bd24e59da96d6cad292e03e.png";